import type { ElementType, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface PanelProps {
  children?: ReactNode;
  className?: string;
  id?: string;
  /** `sm` keeps `px-4 py-4` at all breakpoints. Default `md` grows padding on md+. */
  size?: 'sm' | 'md';
  /** Defaults to `span` (phrasing) so the panel is valid inside a `<button>`. */
  as?: ElementType;
}

/** White content card: rounded-2xl, subtle border, no shadow. */
export default function Panel({ children, className, id, size = 'md', as: Component = 'span' }: PanelProps) {
  return (
    <Component
      id={id}
      className={twMerge(
        'flex w-full flex-col gap-3 rounded-2xl border border-border-subtle bg-surface',
        size === 'sm' ? 'px-4 py-4' : 'px-4 py-4 md:px-6 md:py-5',
        className
      )}
    >
      {children}
    </Component>
  );
}
